var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pull-up",
      attrs: { tile: "", loading: this.loading },
      on: {
        click: function($event) {
          return _vm.openFile(_vm.name)
        }
      }
    },
    [
      _c(
        "v-list-item",
        { staticClass: "py-4 px-8" },
        [
          _c(
            "v-list-item-avatar",
            [
              _c("v-icon", { attrs: { large: "", color: "red" } }, [
                _vm._v(" mdi-adobe-acrobat ")
              ])
            ],
            1
          ),
          _c(
            "v-list-item-content",
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _vm.isBill
                    ? _c(
                        "v-col",
                        { staticClass: "text-center justify-center" },
                        [
                          _c("div", { staticClass: "miniTitle" }, [
                            _vm._v("NÚMERO DE " + _vm._s(_vm.type))
                          ]),
                          _c("div", { staticClass: "overline" }, [
                            _vm._v(_vm._s(_vm.number))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.isHealth
                    ? _c(
                        "v-col",
                        { staticClass: "text-center justify-center" },
                        [
                          _c("div", { staticClass: "miniTitle" }, [
                            _vm._v("TRIMESTRE")
                          ]),
                          _c("div", { staticClass: "overline" }, [
                            _vm._v(_vm._s(_vm.name))
                          ])
                        ]
                      )
                    : _c(
                        "v-col",
                        { staticClass: "text-center justify-center" },
                        [
                          _c("div", { staticClass: "miniTitle" }, [
                            _vm._v("FECHA")
                          ]),
                          _c("div", { staticClass: "overline" }, [
                            _vm._v(_vm._s(_vm.reformatedDate))
                          ])
                        ]
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }